function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { AllhomesListingCardFeatures, AllhomesListingCardImages } from '../../components';
import * as styles from './new-developments-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var NewDevelopmentsCard = props => {
  var _props$url, _props$title;
  return ___EmotionJSX("a", {
    className: props.className,
    css: styles.container,
    href: (_props$url = props.url) !== null && _props$url !== void 0 ? _props$url : undefined
  }, ___EmotionJSX(AllhomesListingCardImages, _extends({
    css: styles.image,
    isResponsive: false
  }, props.images)), ___EmotionJSX("div", {
    css: styles.details
  }, ___EmotionJSX("div", {
    css: styles.detailsText
  }, ___EmotionJSX("p", {
    css: styles.detailsPrice
  }, props.price), ___EmotionJSX("p", {
    css: styles.detailsTitle,
    title: (_props$title = props.title) !== null && _props$title !== void 0 ? _props$title : ''
  }, props.title)), ___EmotionJSX(AllhomesListingCardFeatures, _extends({
    css: styles.features
  }, props.features))));
};